import { ManualTaskDefinition, NodeDefinitions } from './types'
import { customerInfoReviewManualTask } from 'Automations/watchtower/inbox/manualTasks/definitions/customerInfoReview'
import { CUSTOMER_INFO_REVIEW_TYPE } from 'Automations/watchtower/inbox/manualTasks/definitions/customerInfoReview/constants'
import { invoiceUpdateReviewManualTask } from 'Automations/watchtower/inbox/manualTasks/definitions/invoiceUpdateReview'
import { INVOICE_UPDATE_REVIEW_TYPE } from 'Automations/watchtower/inbox/manualTasks/definitions/invoiceUpdateReview/constants'

import {
  endNodeDefinition,
  startContractUploadedNodeDefinition,
  startInvoiceSentNodeDefinition,
  startPlaceholderNodeDefinition,
  startQuoteRequiresApprovalNodeDefinition,
  reviewQuoteNodeDefinition,
  reviewContractNodeDefinition,
  reviewPlaceholderNodeDefinition,
  actionPublishQuoteNodeDefinition,
  actionCreateScheduleNodeDefinition,
  actionPlaceholderNodeDefinition,
  noteNodeDefinition,
  actionContractExtractionNodeDefinition,
  switchNodeDefinition,
  reminderNodeDefinition
} from './definitions'

export const nodeDefinitions: NodeDefinitions = {
  // Start
  START_PLACEHOLDER: startPlaceholderNodeDefinition,
  START_QUOTE_REQUIRES_APPROVAL: startQuoteRequiresApprovalNodeDefinition,
  START_CONTRACT_UPLOADED: startContractUploadedNodeDefinition,
  START_INVOICE_SENT: startInvoiceSentNodeDefinition,
  // Review
  REVIEW_PLACEHOLDER: reviewPlaceholderNodeDefinition,
  REVIEW_QUOTE: reviewQuoteNodeDefinition,
  REVIEW_CONTRACT: reviewContractNodeDefinition,
  // Action
  ACTION_PUBLISH_QUOTE: actionPublishQuoteNodeDefinition,
  ACTION_CREATE_SCHEDULE: actionCreateScheduleNodeDefinition,
  ACTION_CONTRACT_EXTRACTION: actionContractExtractionNodeDefinition,
  ACTION_PLACEHOLDER: actionPlaceholderNodeDefinition,
  // Conditionals
  SWITCH: switchNodeDefinition,
  // Other
  REMINDER: reminderNodeDefinition,
  NOTE: noteNodeDefinition,
  END: endNodeDefinition
}

export const manualReviewTasks: Record<string, ManualTaskDefinition> =
  Object.values(nodeDefinitions).reduce<Record<string, ManualTaskDefinition>>(
    (acc, entry) => {
      // Async registry entries (functions) resolve their definition at load and
      // never carry a manual task, so they contribute nothing here.
      if (typeof entry === 'function' || !entry.manualTask) return acc

      const { type, ...manualTaskDefinition } = entry.manualTask
      return { ...acc, [type]: manualTaskDefinition }
    },
    {
      // Manual tasks not driven by an automation node: the support agent logs
      // proposed customer-info and invoice changes directly to the watchtower.
      [CUSTOMER_INFO_REVIEW_TYPE]: customerInfoReviewManualTask,
      [INVOICE_UPDATE_REVIEW_TYPE]: invoiceUpdateReviewManualTask
    }
  )
